import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-project-table-row.css.lit';
import { classMap } from 'lit/directives/class-map.js';

type Variants = 'default' | 'clean';

/**
 * The IdbProjectTableRow component
 * @element idb-project-table-row
 * @slot - stat-type - for adding a stat type
 * @slot - stat-data - for adding a stat data
 */
@customElement('idb-project-table-row')
export class IdbProjectTableRow extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, attribute: 'variant' })
  variant: Variants = 'default';

  render(): TemplateResult {
    const rowClasses = {
      row: true,
      [`variant--${this.variant}`]: true,
    };

    return html`
      <div class=${classMap(rowClasses)}>
        <div class="stat-type">
          <slot name='stat-type'></slot>
        </div>
        <div class="stat-data">
          <slot name='stat-data'></slot>
        </div>
      </div>
    `;
  }
}
